<template>
  <DemonstratorListComponent
    :demonstrators="demoHistory"
    @demo-selected="demoSelected"
  />
</template>

<script lang="ts" setup>
import type { Demonstrator } from '~/types/account'
import DemonstratorListComponent from '~/components/account/demonstrator/DemonstratorList.vue'

const props = defineProps<{
    recentDemonstrators: Demonstrator[],
  }>()

const emits = defineEmits<{
  (e: 'demo-selected', demonstrator: Demonstrator): void
}>()

const demoHistory = ref(props.recentDemonstrators)

const demoSelected = (demonstrator: Demonstrator) => {
  demoHistory.value = []
  emits('demo-selected', demonstrator)
}
</script>

<style lang="scss" scoped>
</style>
